// @flow

import DownloadIcon from './Download';
import SurvivalIcon from './SurvivalIcon';
import SortIcon from './Sort';
import SpinnerIcon from './Spinner';
import DoubleArrowLeftIcon from './DoubleArrowLeft';
import DoubleArrowRightIcon from './DoubleArrowRight';
import ShoppingCartIcon from './ShoppingCart';
import FileIcon from './File';
import CaseIcon from './Case';
import SaveIcon from './Save';
import GdcDataIcon from './GdcData';
import GridIcon from './Grid.js';
import CaretIcon from './Caret';
import QuestionIcon from './Question';
import ExclamationTriangleIcon from './ExclamationTriangle';
import TrashIcon from './Trash';
import AnalysisIcon from './Analysis';
import MicroscopeIcon from './Microscope';

export {
  DownloadIcon,
  SurvivalIcon,
  SortIcon,
  SpinnerIcon,
  DoubleArrowLeftIcon,
  DoubleArrowRightIcon,
  ShoppingCartIcon,
  FileIcon,
  CaseIcon,
  SaveIcon,
  GdcDataIcon,
  GridIcon,
  CaretIcon,
  QuestionIcon,
  ExclamationTriangleIcon,
  TrashIcon,
  AnalysisIcon,
  MicroscopeIcon,
};



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/theme/icons/index.js